import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import InfoCard from '../components/InfoCard';
import CallToAction from '../components/CallToAction';
import './Home.css';

import bannerImage from '../assets/images/banner.jpg';
import ai1 from '../assets/images/ai1.jpg';
import ai2 from '../assets/images/ai2.jpg';
import ai3 from '../assets/images/ai3.jpg';

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <title>ProgenX - Yazılım ve Bilişim Teknolojileri | Yapay Zeka, IoT, Akıllı Raporlama 2026</title>
        <meta name="description" content="ProgenX, yazılım geliştirme, yapay zeka, IoT ve akıllı raporlama çözümleri sunan yenilikçi bir teknoloji şirketidir. Eğitim, sağlık ve endüstri alanlarında dijital dönüşüm projeleriniz için güvenilir çözüm ortağınız." />
        <meta name="keywords" content="progenx, yazılım geliştirme, yapay zeka, IoT, akıllı raporlama, kurumsal yazılım, mobil uygulama, web geliştirme, bilişim teknolojileri, dijital dönüşüm" />
        <meta property="og:title" content="ProgenX | Yazılım ve Bilişim Teknolojileri" />
        <meta property="og:description" content="Yazılım, yapay zeka, IoT ve akıllı raporlama çözümleri ile dijital geleceğinizi şekillendiriyoruz." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr" />
        <meta property="og:image" content="https://progenx.com.tr/banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ProgenX | Yazılım ve Bilişim Teknolojileri" />
        <meta name="twitter:description" content="Yazılım, yapay zeka, IoT ve akıllı raporlama çözümleri." />
        <link rel="canonical" href="https://progenx.com.tr" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "ProgenX",
            "url": "https://progenx.com.tr",
            "logo": "https://progenx.com.tr/logo.png",
            "description": "Yazılım geliştirme, yapay zeka, IoT ve akıllı raporlama çözümleri sunan teknoloji şirketi",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Üniversiteler Mah. İhsan Doğramacı Bul. No: 31 İç Kapı No: 20",
              "addressLocality": "Çankaya",
              "addressRegion": "Ankara",
              "addressCountry": "TR"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+90-538-686-54-16",
              "contactType": "customer service",
              "email": "info@progenx.com.tr"
            },
            "sameAs": [
              "https://tr.linkedin.com/company/progenx-academy",
              "https://www.instagram.com/progenxacademy/"
            ]
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="PROGENX" 
        subtitle={'"Geleceği tahmin etmenin en iyi yolu onu oluşturmaktır." -Peter Drucker & Abraham Lincoln'}
        buttonText="Hakkımızda" 
        buttonLink="/hakkinda" 
        backgroundImage={bannerImage}
        isHomePage={true}
      />
      
      <section className="home-intro">
        <div className="container">
          <h2 className="section-title">Yazılım ve Teknoloji Çözümleriyle Geleceğinizi Şekillendirin</h2>
          <p className="intro-text">
            ProgenX olarak, eğitimden endüstriye geniş bir yelpazede yazılım çözümleri üretiyoruz. 
            Yapay zeka destekli akıllı sistemler, IoT entegrasyonları ve kurumsal yazılım projeleriyle 
            işletmelerin dijital dönüşüm süreçlerinde güvenilir teknoloji ortağıyız. 
            Yenilikçi çözümlerimizle iş süreçlerinizi optimize ediyor, verilerinizi değere dönüştürüyoruz.
          </p>
          
          <div className="card-row">
            <div className="card-column">
              <InfoCard 
                title="Özel Yazılım Çözümleri" 
                description="İşletmenize özel web, mobil ve masaüstü uygulamalar geliştiriyoruz. Kurumsal ihtiyaçlarınıza uygun, ölçeklenebilir ve güvenilir yazılım projeleriyle iş süreçlerinizi dijitalleştiriyoruz. Modern teknolojilerle en yüksek performansı sağlıyoruz."
                image={ai1}
              />
            </div>
            <div className="card-column">
              <InfoCard 
                title="Veri Bilimi ve Yapay Zeka" 
                description="Büyük veri setlerinden anlamlı bilgiler çıkarıyor, yapay zeka ve makine öğrenmesi modelleriyle işletmelerin karar alma süreçlerini güçlendiriyoruz. Akıllı raporlama ve tahminleme sistemleriyle verilerinizi değere dönüştürüyoruz."
                image={ai2}
              />
            </div>
            <div className="card-column">
              <InfoCard 
                title="IoT ve Akıllı Sistemler" 
                description="Nesnelerin interneti (IoT) çözümleriyle cihazlarınızı birbirine bağlıyor, gömülü sistemler ve akıllı sensör entegrasyonlarıyla endüstriyel süreçlerinizi otomatikleştiriyoruz. Gerçek zamanlı veri toplama ve analiz ile operasyonel verimlilik sağlıyoruz."
                image={ai3}
              />
            </div>
          </div>
        </div>
      </section>
      
      <CallToAction 
        title="Dijital Dönüşüm Yolculuğunuzda Yanınızdayız"
        subtitle="Projenizi konuşalım, birlikte en doğru çözümü üretelim."
        buttonText="Bize Ulaşın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default Home;
